// Mock data for Moleboheng Matli Foundation clone

export const SITE = {
  name: 'Moleboheng Matli Foundation',
  tagline: '"Scars turned into Stars"',
  email: 'info@molebohengmatlifoundation.org.za',
  phone: '+27 67 381 3988',
  phoneAlt: '+27110753222',
  logo: 'https://molebohengmatlifoundation.org.za/assets/images/resources/logo.png',
  whatsappChannel: 'https://whatsapp.com/channel/0029VbAwgy47dmeeh3vv2N0t',
};

export const NAV_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Team', to: '/team' },
  { label: 'Projects', to: '/projects' },
  { label: 'Events', to: '/events' },
  { label: 'Funding', to: '/funding' },
  { label: 'FAQs', to: '/faqs' },
  { label: 'Contact', to: '/contact' },
];

export const HERO_SLIDES = [
  {
    subtitle: 'Bridging The Gender Gap In Education',
    title: 'Empowering African Girls for a Brighter Future',
    cta: 'Read More',
    ctaTo: '/about',
    image: 'https://images.pexels.com/photos/27010242/pexels-photo-27010242.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    subtitle: 'Education Beyond Borders',
    title: 'Connecting African Girls to Global Opportunities',
    cta: 'Cases',
    ctaTo: '/contact',
    image: 'https://images.pexels.com/photos/36467885/pexels-photo-36467885.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    subtitle: 'International Boy Child Day',
    title: 'Raising Awareness, Building a Better World',
    cta: 'Learn More',
    ctaTo: '/boychild',
    image: 'https://customer-assets.emergentagent.com/job_site-architecture-1/artifacts/ez2nox1o_4.jpeg',
  },
  {
    subtitle: 'Learning, Growing, Thriving',
    title: 'Nurturing Bright Minds in Impoverished Communities',
    cta: 'Start a Project',
    ctaTo: '/contact',
    image: 'https://images.pexels.com/photos/36467878/pexels-photo-36467878.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    subtitle: 'Unlocking Potential Through Literacy',
    title: 'Building a Stronger Africa One Girl at a Time',
    cta: 'What we do',
    ctaTo: '/contact',
    image: 'https://images.pexels.com/photos/14909652/pexels-photo-14909652.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
];

export const ABOUT_TEXT = `Moleboheng Matli Foundation (MMF) is an education development NON PROFIT ORGANIZATION with a unique African orientation. It was established to afford every black girl and woman an opportunity to get an education across board while placing an emphasis on literacy enhancement in both rural and impoverished black communities. With an identified gap in the Education Ministry, we wish to offer integrated education training solutions to unlock possibilities for learners and assist the Ministry to fulfill its mandate in driving South Africa's Economic and Social development through learning.`;

export const ABOUT_IMAGES = {
  primary: 'https://customer-assets.emergentagent.com/job_site-architecture-1/artifacts/3ld220bl_1.jpg',
  secondary: 'https://customer-assets.emergentagent.com/job_site-architecture-1/artifacts/fqlc4wvg_2.jpg',
};

export const STATS = [
  { value: 4860, label: 'Children helped' },
  { value: 79, label: 'Projects completed' },
  { value: 53, label: 'Volunteers' },
  { value: 12, label: 'Funders' },
];

export const SERVICES = [
  {
    title: 'Digital Learning Initiatives',
    desc: 'We provide access to digital classrooms and e-learning platforms, allowing girls to access educational content and resources online, bridging the digital divide.',
    image: 'https://images.pexels.com/photos/11025019/pexels-photo-11025019.jpeg?auto=compress&cs=tinysrgb&w=900',
  },
  {
    title: 'Community Outreach and Support',
    desc: 'MMF is committed to supporting impoverished communities through various outreach programs, including mobile libraries, holiday camps, and community book clubs to foster a love for learning.',
    image: 'https://customer-assets.emergentagent.com/job_site-architecture-1/artifacts/tyfx6wx2_9.jpeg',
  },
  {
    title: 'Girl Child Education Programs',
    desc: 'We offer comprehensive educational support and scholarships for girls, ensuring they have access to quality schooling, textbooks, and other educational resources.',
    image: 'https://images.pexels.com/photos/28593048/pexels-photo-28593048.jpeg?auto=compress&cs=tinysrgb&w=900',
  },
  {
    title: 'Literacy Enhancement Workshops',
    desc: 'Our foundation conducts literacy workshops and programs to improve reading and writing skills among girls and women, empowering them with essential life skills.',
    image: 'https://images.pexels.com/photos/35610368/pexels-photo-35610368.jpeg?auto=compress&cs=tinysrgb&w=900',
  },
  {
    title: 'International Exchange and Language Programs',
    desc: 'We organize international exchange programs to broaden horizons and promote cultural diversity.',
    image: 'https://images.unsplash.com/photo-1718638367063-24260e56901f?auto=format&fit=crop&w=900&q=80',
  },
];

export const VISION_TABS = [
  {
    key: 'vision',
    label: 'Our Vision',
    letter: 'V',
    title: 'Pioneering Transformation',
    subtitle: 'Through Education and Literacy',
    body: 'Our vision is to become pioneers in transforming impoverished black communities through education and literacy enhancement. We envision a future where every African girl and woman has the opportunity to reach their full potential, irrespective of their socio-economic background.',
    image: 'https://images.unsplash.com/photo-1497375638960-ca368c7231e4?auto=format&fit=crop&w=1200&q=80',
  },
  {
    key: 'mission',
    label: 'Our Mission',
    letter: 'M',
    title: 'Empowering African Girls and',
    subtitle: 'Women Through Education and Literacy',
    body: 'Our mission at MMF is to empower African girls and women with the liberation of education and literacy for a richer Africa. We are deeply committed to addressing the gender disparities in education, recognizing that education is not only a fundamental right but also a catalyst for personal and societal development.',
    image: 'https://images.pexels.com/photos/28646079/pexels-photo-28646079.jpeg?auto=compress&cs=tinysrgb&w=1200',
  },
  {
    key: 'values',
    label: 'Our Core Values',
    letter: 'C',
    title: 'Guiding Principles for Empowering',
    subtitle: 'African Girls and Women',
    body: 'Our core values\u2014Dynamic, Passionate, Committed, Proactive, and Goal-Oriented\u2014constitute the bedrock of our organizational culture. These values drive our unwavering commitment to bridging the gender gap in education and literacy. We are dynamic, adapting to evolving needs; our passion fuels our determination; commitment keeps us on course; proactivity helps us anticipate challenges and opportunities, and a goal-oriented mindset ensures that we measure our impact. Together, these values propel our mission to empower African girls and women, illuminating the path to a brighter future through education and literacy.',
    image: 'https://customer-assets.emergentagent.com/job_site-architecture-1/artifacts/383q526p_image.png',
  },
];

export const WAYS = [
  'Volunteer and Support',
  'Advocate and Raise Awareness',
  'Educate Yourself and Others',
];

export const VIDEOS = [
  {
    title: 'Empowering futures through a legacy of leadership and advocacy.',
    body: "Mrs. Beverly Robertson is a distinguished leader renowned for her transformative roles in civil rights advocacy and economic development. As the former President & CEO of both the National Civil Rights Museum and the Greater Memphis Chamber of Commerce, she has championed initiatives that foster equity and opportunity. Her commitment to uplifting communities aligns seamlessly with the Foundation's mission to empower African girls and women through education and literacy.",
    youtubeId: '95xFmQaIMoU',
    reverse: false,
  },
  {
    title: 'From dreams to reality: A journey of empowerment through education.',
    body: "Bohlale M represents the transformative impact of the Moleboheng Matli Foundation's educational programs. As a young girl from South Africa, her journey underscores the Foundation's dedication to bridging educational gaps and nurturing the potential of African girls. Through access to quality education and support, Bohlale's story is a testament to the Foundation's vision of a brighter, more equitable future. She is one of the few girls who have been given access to foreign scholarship in the United States courtesy of the Moleboheng Matli Foundation.",
    youtubeId: 'gb2AeFqvxnM',
    reverse: true,
  },
];

export const TESTIMONIALS = [
  { name: 'Sarah Johnson', role: 'Beneficiary', text: "I've had the privilege of being part of MMF's programs, and it's been life-changing. They provide opportunities and support for girls that make a real difference." },
  { name: 'Michael Brown', role: 'Advocate', text: "MMF's initiatives are essential for breaking down barriers and promoting equality in education. Their proactive approach to change is inspiring." },
  { name: 'Amina Kamara', role: 'Beneficiary', text: 'The Moleboheng Matli Foundation has opened doors for me that I never thought possible. Their commitment to education and literacy has transformed my life.' },
  { name: 'Jane Smith', role: 'Supporter', text: "The Moleboheng Matli Foundation is making a significant impact on the lives of young girls in Africa. Their commitment to education and literacy is inspiring, and I'm proud to support their mission." },
  { name: 'Jamie Polina', role: 'Volunteer', text: "As a volunteer, I've seen firsthand the dedication and passion of MMF's team. Their work in empowering girls through education is changing lives and the future of Africa." },
];

export const PARTNERS = [
  'https://molebohengmatlifoundation.org.za/assets/images/brand/brand-1-img-1.png',
  'https://molebohengmatlifoundation.org.za/assets/images/brand/brand-1-img-2.png',
  'https://molebohengmatlifoundation.org.za/assets/images/brand/brand-1-img-3.png',
  'https://molebohengmatlifoundation.org.za/assets/images/brand/brand-1-img-4.png',
  'https://molebohengmatlifoundation.org.za/assets/images/brand/brand-1-img-5.png',
  'https://molebohengmatlifoundation.org.za/assets/images/brand/brand-2-img-1.png',
  'https://molebohengmatlifoundation.org.za/assets/images/brand/brand-2-img-2.png',
  'https://molebohengmatlifoundation.org.za/assets/images/brand/brand-2-img-3.png',
  'https://molebohengmatlifoundation.org.za/assets/images/brand/brand-2-img-4.png',
  'https://molebohengmatlifoundation.org.za/assets/images/brand/brand-2-img-5.png',
];

export const PROJECTS = [
  {
    title: 'Maokeng learners uniform project',
    location: 'Maokeng',
    image: 'https://images.unsplash.com/photo-1497633762265-9d179a990aa6?auto=format&fit=crop&w=800&q=80',
    desc: 'As it is said, "Charity begins at home", the founder and chairman of the foundation MOLEBOHENG MATLI chose her childhood primary school Maokeng Public School as the first (1st) beneficiary of the foundation.',
  },
  {
    title: 'Moqhaka Municipality Mobile Library',
    location: 'Free State Province',
    image: 'https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&w=800&q=80',
    desc: 'Motivated and guided the learners in reading and cultivating a love for books.',
  },
  {
    title: 'MAKHETHE PRIMARY, SCHOLAR ADOPTION',
    location: 'Free State Province',
    image: 'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=800&q=80',
    desc: 'Fostering Bright Futures, One Scholar at a Time: Empowering Minds, Nurturing Dreams at Makhethe Primary School.',
  },
  {
    title: "NKOSI's HAVEN CHRISTMAS PROJECT",
    location: 'Free State Province',
    image: 'https://images.unsplash.com/photo-1543589077-47d81606c1bf?auto=format&fit=crop&w=800&q=80',
    desc: "Spreading Joy, Hope, and Warmth: Nkosi's Haven Christmas Project Making a Difference in the Community.",
  },
  {
    title: 'THE VILLA OF HOPE ADOPTION PROJECT',
    location: 'Free State Province',
    image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=800&q=80',
    desc: 'Empowering Lives, Creating Smiles.',
  },
];

export const FAQS = [
  { q: 'What is the Moleboheng Matli Foundation?', a: 'MMF is a South African non-profit dedicated to empowering African girls and women through education and literacy, with a focus on impoverished black communities.' },
  { q: 'How can I donate to support the foundation?', a: 'You can donate via the Donate button at the top of the site, or contact us directly for partnership and sponsorship opportunities.' },
  { q: 'How can I become a volunteer?', a: 'Visit our Contact page and submit the form indicating your interest in volunteering. Our team will reach out with current opportunities.' },
  { q: 'Where does the foundation operate?', a: 'We primarily operate in South Africa, with partnerships extending across the African continent and internationally for exchange programs.' },
  { q: 'Are donations tax deductible?', a: 'As a registered Public Benefit Organisation in South Africa, donations may qualify for Section 18A tax deduction certificates. Contact us for details.' },
  { q: 'How are funds used?', a: 'Funds support scholarships, literacy workshops, digital classrooms, mobile libraries, and community outreach programs across our focus areas.' },
  { q: 'Can I partner my company with MMF?', a: 'Absolutely. We welcome corporate partnerships. Please reach out via the Contact page and our team will arrange a meeting.' },
  { q: 'How do you choose beneficiaries?', a: 'Beneficiaries are selected based on academic merit, financial need, and community impact through a transparent application process.' },
];
